var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup29(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.167,
    viewBox: "0 0 30 29.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-26 -171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(34 177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle2847",
    d: "M7.505,290.9a4.47,4.47,0,0,0-2.574,8.13,7.269,7.269,0,0,0-4.57,6.737.706.706,0,1,0,1.411,0,5.845,5.845,0,0,1,8.921-4.972.706.706,0,1,0,.738-1.2,7.257,7.257,0,0,0-1.287-.61,4.47,4.47,0,0,0-2.64-8.08Zm0,1.412a3.064,3.064,0,1,1-3.067,3.067,3.055,3.055,0,0,1,3.067-3.067Zm4.327,12v1.411a.706.706,0,0,0,1.411,0v-1.411h1.412a.706.706,0,0,0,0-1.412H13.244v-1.411a.705.705,0,1,0-1.411,0V302.9H10.388a.706.706,0,1,0,.034,1.412Z",
    transform: "translate(-0.362 -290.902)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(26 171)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 14.583,
    rx: 15,
    ry: 14.583,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 14.583,
    rx: 14.5,
    ry: 14.083,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup29);
export default __webpack_public_path__ + "static/media/Group 29.1158c2e3ad56b330747c600f532089a4.svg";
export { ForwardRef as ReactComponent };